import { render, staticRenderFns } from "./MapIconMuseumWin.vue?vue&type=template&id=34034035&scoped=true&"
import script from "./MapIconMuseumWin.vue?vue&type=script&lang=js&"
export * from "./MapIconMuseumWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34034035",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34034035')) {
      api.createRecord('34034035', component.options)
    } else {
      api.reload('34034035', component.options)
    }
    module.hot.accept("./MapIconMuseumWin.vue?vue&type=template&id=34034035&scoped=true&", function () {
      api.rerender('34034035', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconMuseumWin.vue"
export default component.exports